// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"QoNN3q","errorMessage":"VZAJnp","errorIcon":"orm0mu"};